import Entreprise from "./entreprise";
export default class Client {
  constructor(data) {
    // Stocker les données brutes pour y accéder plus tard
    this._rawData = data || {};
    this.id = data.id;
    this.nom = data.nom;
    this.prenom = data.prenom;
    this.full_name = data.nom + " " + data.prenom;
    this.email = data.email;
    this.rue = data.rue;
    this.cp = data.cp;
    this.ville = data.ville;
    this.tel = data.tel;
    this.phone = data.phone;
    this.type = data.type;
    this.entreprise = Entreprise.create(data.entreprise);
    this.devis_signed = data.devis_signed;
    this.facture_signed = data.facture_signed;
    this.company = data.company;
    this.company_email = data.company_email;
    this.company_tel = data.company_tel;
    this.company_phone = data.company_phone;
    this.pays = data.pays;
    this.SWIFT_BIC = data.SWIFT_BIC;
    this.forme_juridique=data.forme_juridique;
    this.naf=data.naf;
    this.ape=data.ape;
    this.IBAN = data.IBAN;
    this.siret = data.siret;
    this.num_tva = data.num_tva;
    this.titulaire_compte = data.titulaire_compte;
    this.poste = data.poste;
    this.commentaire = data.commentaire;
    this.created_at = data.created_at;
    this.zone = data.zone; 
    this.precarite = data.precarite;
    // this.type_chauffage = data.type_chauffage;
    // this.type_logement = data.type_logement;
    this.revenu_avis_imposition=data.revenu_avis_imposition;
    this.num_client=data.num_client;
    this.logements=data.logements;
    this.menage=data.menage;
    // Champs pour les clients particuliers
    this.civilite_1 = data.civilite_1;
    this.civilite_2 = data.civilite_2;
    this.nom_2 = data.nom_2;
    this.prenom_2 = data.prenom_2;
    this.email_2 = data.email_2;
    this.complement_adresse = data.complement_adresse;
    this.tel_fixe = data.tel_fixe;
    this.tel_fixe_phone_number = data.tel_fixe_phone_number;
    this.tel_fixe_phone_iso_code = data.tel_fixe_phone_iso_code;
    this.tel_mobile = data.tel_mobile;
    // Champs pour les clients professionnels
    this.civilite = data.civilite;
    this.raison_sociale = data.raison_sociale;
    this.nom_commercial = data.nom_commercial;
    this.signataire_nom = data.signataire_nom;
    this.signataire_prenom = data.signataire_prenom;
    this.fonction = data.fonction;
    this.email = data.email;
    this.tel_mobile_pro = data.tel_mobile_pro;
    this.tel_fixe_pro = data.tel_fixe_pro;
    this.type_occupation = data.type_occupation;
  }
  update(data) {
    this.nom = data.nom;
    this.prenom = data.prenom;
    this.email = data.email;
    this.rue = data.rue;
    this.cp = data.cp;
    this.ville = data.ville;
    this.tel = data.tel;
    this.phone = data.phone;
    this.company_phone = data.company_phone;
    this.type = data.type;
    this.devis_signed = data.devis_signed;
    this.facture_signed = data.facture_signed;
    this.company = data.company;
    this.company_email = data.company_email;
    this.company_tel = data.company_tel;
    this.pays = data.pays;
    this.SWIFT_BIC = data.SWIFT_BIC;
    this.forme_juridique=data.forme_juridique;
    this.naf=data.naf;
    this.ape=data.ape;
    this.IBAN = data.IBAN;
    this.siret = data.siret;
    this.num_tva = data.num_tva;
    this.titulaire_compte = data.titulaire_compte;
    this.poste = data.poste;
    this.commentaire = data.commentaire;
    this.created_at = data.created_at;
    this.zone = data.zone; 
    this.precarite = data.precarite;
    // this.type_chauffage = data.type_chauffage;
    // this.type_logement = data.type_logement;
    this.revenu_avis_imposition=data.revenu_avis_imposition;
    this.num_client=data.num_client;
    this.logements=data.logements;
    this.menage=data.menage;
    // Champs pour les clients particuliers
    this.civilite_1 = data.civilite_1;
    this.civilite_2 = data.civilite_2;
    this.nom_2 = data.nom_2;
    this.prenom_2 = data.prenom_2;
    this.email_2 = data.email_2;
    this.complement_adresse = data.complement_adresse;
    this.tel_fixe = data.tel_fixe;
    this.tel_fixe_phone_number = data.tel_fixe_phone_number;
    this.tel_fixe_phone_iso_code = data.tel_fixe_phone_iso_code;
    this.tel_mobile = data.tel_mobile;
    // Champs pour les clients professionnels
    this.civilite = data.civilite;
    this.raison_sociale = data.raison_sociale;
    this.nom_commercial = data.nom_commercial;
    this.signataire_nom = data.signataire_nom;
    this.signataire_prenom = data.signataire_prenom;
    this.fonction = data.fonction;
    this.email = data.email;
    this.tel_mobile_pro = data.tel_mobile_pro;
    this.tel_fixe_pro = data.tel_fixe_pro;
    this.type_occupation = data.type_occupation;
  }

  static create(data) {
    return new Client(data);
  }
}
